import PropTypes from 'prop-types';
import React from 'react';

import useTranslation from '../../hooks/use_translation';

const Countdown = ({ timeLeft }) => {
	const { t } = useTranslation('component_countdown');

	const formatNumber = (number) => {
		return number.split('').map((digit, index) => (
			<span
				className="bg-dark text-white rounded-1 px-1"
				key={index}
				style={{ marginRight: '1px' }}
			>
				{digit}
			</span>
		));
	};

	if (!timeLeft) return null;
	return (
		<div className="d-flex gap-1 justify-content-center">
			<div className="count-down">
				{formatNumber(timeLeft.days)}
				<div className="count-down-label">{t('t1')}</div>
			</div>
			{':'}
			<div className="count-down">
				{formatNumber(timeLeft.hours)}
				<div className="count-down-label">{t('t2')}</div>
			</div>
			{':'}
			<div className="count-down">
				{formatNumber(timeLeft.minutes)}
				<div className="count-down-label">{t('t3')}</div>
			</div>
			{':'}
			<div className="count-down">
				{formatNumber(timeLeft.seconds)}
				<div className="count-down-label">{t('t4')}</div>
			</div>
		</div>
	);
};

Countdown.propTypes = {
	timeLeft: PropTypes.object.isRequired,
};

export default Countdown;
